(() => {
  document.querySelectorAll('.announcement-bar--mobile-menu').forEach(bar => {
    const clone = bar.cloneNode(true);
    clone.id += '-clone';

    document.querySelector('.menu-drawer__announcements').appendChild(clone);
  });
})();